import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Shield, ChevronRight } from 'lucide-react';
import SEO from '../components/SEO';

export const Privacy = () => {
  const { t } = useTranslation();

  const sections = Array.from({ length: 10 }, (_, i) => i + 1);

  return (
    <div className="pt-24 pb-12 px-4 max-w-4xl mx-auto bg-white dark:bg-gray-900 min-h-screen">
      <SEO
        title={`${t('navigation.privacy') || 'Privacy'} – Victor Lazari`}
        description={t('privacy.title') as string}
        canonical={"https://victorlazari.com/privacy"}
        image={"https://raw.githubusercontent.com/VictorLazari-lab/victorlazari.com/VictorLazari-Media/varienda%20minimalist%20logo.png"}
        type="website"
      />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-12"
      >
        <h1 className="text-4xl md:text-5xl font-semibold text-slate-900 dark:text-gray-100 flex items-center justify-center gap-3">
          <Shield className="w-10 h-10" />
          {t('privacy.title')}
        </h1>
      </motion.div>

      <div className="space-y-8">
        {sections.map((section) => {
          // Try to get items, default to empty array if not found
          const items = t(`privacy.section${section}.items`, { returnObjects: true, defaultValue: [] });
          
          return (
            <motion.section
              key={section}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="bg-white dark:bg-gray-800 rounded-xl p-6 border border-slate-200 dark:border-gray-700 shadow-sm"
            >
              <h2 className="text-xl font-semibold text-slate-900 dark:text-gray-100 mb-4">
                {t(`privacy.section${section}.title`)}
              </h2>
              
              <p className="text-slate-600 dark:text-gray-300 mb-4">
                {t(`privacy.section${section}.content`)}
              </p>

              {Array.isArray(items) && items.length > 0 && (
                <ul className="space-y-2">
                  {items.map((item: any, index: number) => (
                    <li key={index} className="flex items-start gap-2 text-slate-600 dark:text-gray-300">
                      <ChevronRight className="w-5 h-5 text-sky-600 dark:text-sky-400 mt-1 flex-shrink-0" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              )}

              {section === 9 && (
                <div className="bg-white dark:bg-gray-700/50 p-4 rounded-lg mt-4 border border-slate-200 dark:border-gray-700">
                  <p className="font-semibold mb-2 text-slate-900 dark:text-gray-100">{t('privacy.section9.contact.title')}</p>
                  <p className="text-slate-600 dark:text-gray-300">Email: victor@victorlazari.com</p>
                  <p className="text-slate-600 dark:text-gray-300">San Pietro in Vinoli, Ravenna, 48125, Italia</p>
                </div>
              )}
            </motion.section>
          );
        })}

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-sm text-slate-500 dark:text-gray-400 text-center mt-8"
        >
          {t('privacy.lastUpdated')}: 30 marzo 2024
        </motion.p>
      </div>
    </div>
  );
}; 